<template>
  <div class="midashi">
    <p class="midashi-msg">{{ Headline }}</p>
  </div>
</template>

<script>
export default {
  name: "HeadLine",
  props: {
    Headline: {
      type: String,
      default: "タイトル",
    },
  },
};
</script>

<style>
h5 {
  text-align: left;
  font-weight: 900;
}
.midashi {
  padding-left: 15%;
  text-align: start;
}
.midashi-msg {
  color: #77a88d;
  font-size: 150%;
  font-weight: 600;
}
@media screen and (max-width: 480px) {
  /* 480px以下に適用されるCSS（スマホ用） */
  .midashi {
    padding-left: 3%;
    text-align: left;
  }
}
</style>
